import { TransitionEffect } from '../../../constants/transition-effect.const';
import { PlaylistItemDTO } from '../playlist-item-models/playlist-item-dto.model';

export class PlaylistDTOModel {
  PlaylistTitle: string;
  PlaylistDescription: string;
  IsRepeated: boolean;
  PlaylistItems: PlaylistItemDTO[] = [];
  UsersWhoHaveAccessIds: string[] = [];
  IsShared: boolean;
  IsSharedWithAllUsers: boolean;
  IsAndroid: boolean;
  Transition: TransitionEffect;
  FitToVideoSize: boolean;

  MachinePhysicalAddress?: string;
  Id?: number;

  constructor(values: Partial<PlaylistDTOModel> = {}) {
    Object.assign(this, values);
  }
}
